let activeLocks = 0;

export function acquireInteractiveCursorLock() {
  if (typeof document === 'undefined') return () => {};

  activeLocks += 1;
  document.documentElement.classList.add('interactive-cursor-lock');

  let released = false;
  return () => {
    if (released) return;
    released = true;
    activeLocks = Math.max(0, activeLocks - 1);
    if (activeLocks === 0) {
      document.documentElement.classList.remove('interactive-cursor-lock');
    }
  };
}
